import { render, staticRenderFns } from "./videoplay.vue?vue&type=template&id=6bf868c3&scoped=true&"
import script from "./videoplay.vue?vue&type=script&lang=js&"
export * from "./videoplay.vue?vue&type=script&lang=js&"
import style0 from "./videoplay.vue?vue&type=style&index=0&id=6bf868c3&scoped=scoped&lang=css&"
import style1 from "./videoplay.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf868c3",
  null
  
)

export default component.exports